<i18n locale="en">
{
  "title": "Confirm delete",
  "message": "Are you sure you want to delete?",
  "actions": {
    "delete": "Delete"
  }
}
</i18n>

<template>
  <OwnDialog v-model="isVisible" @cancel="onCancel">
    <template #heading>
      <OwnDialogHeading :title="title ?? t('title')" @cancel="onCancel" />
    </template>
    <template #default>
      <OwnDialogContent scroll>
        <p
          class="text-paragraph text-color-secondary"
          v-text="message ?? t('message')"
        ></p>
      </OwnDialogContent>
    </template>
    <template #footer="{ close }">
      <OwnDialogFooter>
        <OwnButton
          :text="deleteActionLabel ?? t('actions.delete')"
          :processing="isProcessing"
          danger
          @click="onConfirmDelete(close)"
        />
      </OwnDialogFooter>
    </template>
  </OwnDialog>
</template>

<script>
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import {
  OwnDialog,
  OwnDialogHeading,
  OwnDialogFooter,
  OwnDialogContent,
} from '@/ui/OwnDialog'
import { mapModel } from '@/utils/computed'

export default {
  name: 'DeleteConfirmationDialog',
  components: {
    OwnButton,
    OwnDialog,
    OwnDialogContent,
    OwnDialogFooter,
    OwnDialogHeading,
  },
  emits: ['cancel', 'delete', 'update:modelValue'],
  setup() {
    const { t } = useI18n()
    return { t }
  },
  props: {
    /**
     * Override the delete action label
     */
    deleteActionLabel: { type: String, default: undefined },

    /**
     * Whether the confirm action is processing or not
     */
    isProcessing: { type: Boolean, default: false },

    /**
     * Override default message
     */
    message: { type: String, default: undefined },

    /**
     * Show Modal
     */
    modelValue: { type: Boolean, default: false },

    /**
     * Override default title
     */
    title: { type: String, default: undefined },
  },
  computed: {
    ...mapModel('isVisible'),
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
      this.isVisible = false
    },
    onConfirmDelete(close) {
      this.$emit('delete')
      if (close) {
        close()
      }
    },
  },
}
</script>
